<template>
  <!-- 方案优势 -->
  <div :class="isPcFlag ? 'plan-advantage-pc' : 'plan-advantage-h5'">
    <div class="content">
      <div class="title">方案优势</div>
      <div class="card-box">
        <div class="card-item" v-for="(item, index) in list" :key="index">
          <img class="img" :src="item.img" alt="" />
          <div class="text">{{ item.text }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isPcFlag: Boolean, // 是Pc还是H5
    list: {
      type: Array,
      default: [],
    },
  },
}
</script>

<style lang="less" scoped>
.basisDisplay(@justify,@align) {
  display: flex;
  justify-content: @justify;
  align-items: @align;
}
.columnDisplay(@justify,@align) {
  display: flex;
  flex-direction: column;
  justify-content: @justify;
  align-items: @align;
}
.plan-advantage-pc {
  width: 100%;
  background: #fff;
  padding: 72px 0;
  .content {
    max-width: 1320px;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 61px;
      font-size: 32px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-box {
      width: 100%;
      .basisDisplay(space-around,center);
      .card-item {
        .columnDisplay(center,center);
        .img {
          width: 86px;
          height: 86px;
        }
        .text {
          font-size: 20px;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.85);
          margin: 14px 0;
        }
        .desc {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
}
.plan-advantage-h5 {
  width: 100%;
  background: #fff;
  padding: 1.0667rem 0.4rem;
  .content {
    max-width: 10rem;
    height: 100%;
    margin: 0 auto;
    .columnDisplay(flex-start,center);
    .title {
      margin-bottom: 0.64rem;
      font-size: 0.48rem;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    .card-box {
      width: 100%;
      // .columnDisplay(center,center);
      .card-item {
        .columnDisplay(center,center);
        padding: 0.5333rem 0.6667rem;
        .img {
          width: 1.9467rem;
          height: 1.9467rem;
        }
        .text {
          font-size: 0.4267rem;
          font-weight: 500;
          color: rgba(0, 0, 0, 0.85);
          margin: 0.3733rem 0;
        }
        .desc {
          font-size: 0.3733rem;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
}
</style>